export default __webpack_public_path__ + "static/media/CNo.88-4.5e40feb1.jpg";